"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Heart } from "lucide-react";
import { motion } from "framer-motion";
const Footer = () => {
  const $ = _c(7);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0,
      y: 16
    };
    t1 = {
      opacity: 1,
      y: 0
    };
    t2 = {
      once: true
    };
    t3 = {
      duration: 0.4,
      ease: "easeOut"
    };
    t4 = <span>Made with</span>;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <motion.div className="flex items-center gap-1" initial={t0} whileInView={t1} viewport={t2} transition={t3}>{t4}<motion.div animate={{
        scale: [1, 1.2, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut"
      }}><Heart className="fill-danger" strokeWidth={0} size={16} /></motion.div><span>in India</span></motion.div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <footer className="border-border xs:flex-row xs:gap-1 flex h-12 w-full flex-col items-center justify-center border-t py-2 text-sm backdrop-blur-sm md:sticky md:bottom-0">{t5}<motion.div className="flex items-center gap-1" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.1,
        ease: "easeOut"
      }}><span>by</span><Link className="font-medium" href="/">Karan Jaiswal</Link></motion.div></footer>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
export default Footer;